<div class="bg-card rounded-2xl border border-border overflow-hidden">
  <h3 class="text-[17px] font-bold text-foreground px-4 pt-3.5 pb-2">Trending Topics</h3>
  <div>
    <div *ngFor="let topic of topics" class="px-4 py-2.5 hover:bg-secondary/50 transition-colors cursor-pointer">
      <p class="text-[14px] font-semibold text-foreground">{{ topic.tag }}</p>
      <p class="text-[12px] text-muted-foreground">{{ topic.postCount | number }} posts</p>
    </div>
  </div>
  <button type="button" class="w-full px-4 py-3 text-[14px] text-ts-blue hover:bg-secondary/50 transition-colors text-left">
    Show more
  </button>
</div>
